import {LitElement, html} from "lit";
import {customElement} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";

import {tooltipStyles} from "./Tooltip.styles.js";

@customElement("pn-tooltip")
export class Tooltip extends LitElement {
	static styles = [tooltipStyles];

	// TODO
	tooltipNowrap = false;

	render() {
		// The slot must not have any whitespace around it, or the whitespace
		// will show up in the displayed tooltip
		return html`
			<div
				class=${classMap({
					"tooltip-floating": true,
					"tooltip-nowrap":   this.tooltipNowrap
				})}
				id=${this.id}
				role="tooltip"
			><slot></slot><div class="tooltip-arrow"></div>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-tooltip": Tooltip;
	}
}
